<div class="available-rooms-list relative w-full h-auto !p-4 mt-3">
    <div class="flex !gap-3">
        <ng-container *ngFor="let nameRoom of item.room_name; let last = last">
            <span class="text-lg font-semibold first-letter:capitalize text-palette-gray-900 font-inter whitespace-nowrap text-ellipsis overflow-hidden max-w-[700px]">
                {{ nameRoom }}{{ last ? '' : ',' }}
            </span>
        </ng-container>
    </div>
    <div class="hotel-page-room-type block responsive-flex-900 !gap-4 !mt-2 bg-palette-base-white border border-[#fff] rounded-lg">
        <div class="flex flex-col !gap-1 !mb-2">
            <div class="flex flex-col max-[899px]:!flex-row !gap-2 !max-w-[390px]">
                <div class="min-w-[210px]">
                    <div class="space-y-2 relative">
                        <ng-container *ngIf="item.room_image_overall_id || item.room_image_ids?.length > 0; else noImage">
                            <!-- Main img -->
                            <div *ngIf="item.room_image_overall_id; else notImageID">
                                <img class="!w-[258px] !h-[146px] object-cover rounded-lg bg-palette-gray-200"
                                    [src]="baseUrl + '/storage/files/web/' + item.room_image_overall_id + '.webp'"
                                    (error)="replaceWithDefaultImage($event)" alt="Main Room Image" />
                            </div>
                            <ng-template #notImageID>
                                <div *ngIf="item.room_image_overall_url; else notImage">
                                    <img class="!w-[258px] !h-[146px] object-cover rounded-lg bg-palette-gray-200"
                                        [src]="item.room_image_overall_url" (error)="replaceWithDefaultImage($event)"
                                        alt="Main Room Image" />
                                </div>
                                <ng-template #notImage>
                                    <img class="!w-[258px] !h-[146px] object-cover rounded-lg"
                                        src="assets/images/rooms/default_room.png" alt="Default Room" />
                                </ng-template>
                            </ng-template>
        
                            <!-- Sub image  -->
                            <div *ngIf="item.room_image_ids?.length > 0" class="flex gap-2 mt-2">
                                <ng-container *ngFor="let img of item.room_image_ids.slice(0, 2); let i = index">
                                    <div class="relative w-1/2">
                                        <img class="!w-[127px] !h-[72px] object-cover rounded-lg bg-palette-gray-200"
                                            [src]="baseUrl + '/storage/files/web/' + img + '.webp'"
                                            (error)="replaceWithDefaultImage($event)" alt="Room Sub Image" />
                                        <div *ngIf="i === 1 && item.room_image_ids.length > 2"
                                            class="absolute bottom-2 right-2 flex items-center justify-center gap-[2px] px-1 py-[2px] rounded"
                                            style="background: rgba(0, 0, 0, 0.4);">
                                            <!-- Icon -->
                                            <i class="sctr-icon-solid-image-03 text-white text-xs md:text-sm"></i>
        
                                            <!-- Number of photos remaining -->
                                            <span class="text-white text-xs md:text-sm font-medium">
                                                {{ item.room_image_ids.length - 2 }}
                                            </span>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                        <!-- No img -->
                        <ng-template #noImage>
                            <img class="!w-[120px] !h-[120px] md:!w-[258px] md:!h-[193px] object-cover rounded-lg"
                                src="assets/images/rooms/default_room.png" alt="Default Room" />
                        </ng-template>
                        <ng-container *ngIf="badgeInfo">
                            <div class="absolute bottom-2 left-2 flex rounded-sm"
                                (mouseover)="badgeInfo.badge_info.showTooltip = true;"
                                (mouseleave)="badgeInfo.badge_info.showTooltip = false;">
                                <div class="relative">
                                    <img class="!w-8 !h-8 !p-0.5 rounded" src="{{baseImgUrl}}/{{ badgeInfo.badge_info.avatar}}.webp" alt="">
                                    <div *ngIf="badgeInfo.badge_info.showTooltip"
                                        class="absolute text-xs font-medium text-palette-gray-900 bg-palette-gray-50 
                                            !px-3 !py-2 rounded shadow-md left-full bottom-0 ml-1 whitespace-nowrap">
                                        {{badgeInfo.badge_info.name }}
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="w-full my-3 !py-2 !px-4 h-[36px] text-sm font-inter font-semibold text-palette-gray-900 border border-palette-gray-300 rounded-lg flex justify-center items-center text-center cursor-pointer whitespace-nowrap hover:!bg-palette-gray-50"
                        (click)="handleClickRoomHotel(item)">
                        {{'DETAIL.VIEW_DETAIL' | translate}}
                    </div>
                </div>        
                <div class="!m-0 flex flex-col justify-end gap-2 !mb-3">
                    <!-- View -->
                    <div *ngIf="item.room_view && item.room_view.translate_view_name" class="flex items-center gap-1">
                        <i class="sctr-icon-{{item.room_view.room_view_icon}} text-palette-green-600 text-[16px]"></i>
                        <p
                            class="text-sm font-normal text-palette-green-600 w-full whitespace-nowrap overflow-hidden text-ellipsis">
                            {{item.room_view.translate_view_name }}
                        </p>
                    </div>
                    <!-- Room size -->
                    <div *ngIf="item.room_size" class="flex items-center gap-1">
                        <i class="sctr-icon-expand-03 text-palette-gray-500 text-[16px]"></i>
        
                        <p *ngIf="item.room_size_unit.toLowerCase() !== 'square meters' && item.room_size_unit.toLowerCase() !== 'square feet'"
                            class="text-sm font-normal text-palette-gray-500 w-full whitespace-nowrap overflow-hidden text-ellipsis">
                            {{item.room_size}}{{item.room_size_unit}}
                        </p>
        
                        <p *ngIf="item.room_size_unit.toLowerCase() === 'square feet'"
                            class="text-sm font-normal text-palette-gray-500 w-full whitespace-nowrap overflow-hidden text-ellipsis">
                            {{item.room_size}}<span>ft²</span>
                        </p>
        
                        <p *ngIf="item.room_size_unit.toLowerCase() === 'square meters'"
                            class="text-sm font-normal text-palette-gray-500 w-full whitespace-nowrap overflow-hidden text-ellipsis">
                            {{item.room_size}}<span>m²</span>
                        </p>
                    </div>
                    <!-- Balcony -->
                    <div *ngIf="item.is_balcony" class="flex items-center gap-1">
                        <i class="sctr-icon-perspective-02 text-palette-gray-500 text-[16px]"></i>
                        <p
                            class="text-sm font-normal text-palette-gray-500 w-full whitespace-nowrap overflow-hidden text-ellipsis">
                            {{'COMMON.BALCONY' | translate}}
                        </p>
                    </div>
                    <!-- Shower -->
                    <div *ngIf="item?.shower && item?.shower.translate_shower_name" class="flex items-center gap-1">
                        <i class="sctr-icon-{{item.shower.shower_icon}} text-palette-gray-500 text-[16px]"></i>
                        <p
                            class="text-sm font-normal text-palette-gray-500 w-full whitespace-nowrap overflow-hidden text-ellipsis">
                            {{item.shower.translate_shower_name }}
                        </p>
                    </div>
                    <!-- Amenities -->
                    <div *ngIf="item.room_amenity_list?.length > 0" class="flex items-center gap-1">
                        <i class="sctr-icon-check-circle-broken text-palette-gray-500 text-[16px]"></i>
                        <p
                            class="text-sm font-normal text-palette-gray-500 overflow-hidden text-ellipsis lowercase">
                            +{{ item.room_amenity_list.length }} {{'DETAIL.AMENITIES' | translate}}
                        </p>
                    </div>
                </div>
            </div>
            <!-- Scroll badge -->
            <div *ngIf="displayBadges && displayBadges.length > 0"
                class="flex items-center justify-between" >
                <div class="relative max-w-[250px]">
                    <!-- Scrollable badge list -->
                    <div #badgeContainer
                        class="w-auto flex items-center space-x-2 overflow-x-auto scroll-smooth no-scrollbar cursor-grab active:cursor-grabbing select-none relative z-[5]"
                        style="scroll-behavior: smooth;" 
                        (mousedown)="startDrag($event)" 
                        (mousemove)="onDrag($event)" 
                        (mouseup)="stopDrag()"
                        (mouseleave)="stopDrag()">
                        <div *ngFor="let badge of displayBadges"
                            class="shrink-0 px-2 py-1 rounded whitespace-nowrap text-[10px] leading-[10px] font-medium border flex items-center space-x-1"
                            [ngStyle]="{
                            'background-color': badge.bgColor,
                            'color': badge.color,
                            'border-color': badge.borderColor
                            }">

                            <!-- iconUrl -->
                            <ng-container *ngIf="badge.iconUrl; else iconClass">
                            <img [src]="badge.iconUrl" alt="badge icon" class="w-3 h-3 object-contain" />
                            </ng-container>

                            <!-- iconClass -->
                            <ng-template #iconClass>
                            <i [class]="badge.iconClass" [ngStyle]="{ color: badge.color }"></i>
                            </ng-template>

                            <span>{{ badge.label }}</span>
                        </div>
                    </div>
                </div>

                <!-- Right side: Label -->
                <!-- <div class="ml-2 text-xs md:text-sm font-medium text-rose-500 whitespace-nowrap">
                    <p>Our last room!</p>
                </div> -->
            </div>
        </div>
    
        <div class="flex-1">
            <div class="flex flex-col !gap-2">
                <!-- BED TYPE -->
                <div *ngIf="item.bed_types && item?.bed_types.length > 0"
                    class="flex !gap-5 text-sm font-medium ota-custom w-full my-2 md:my-0">
                    <div class="flex !gap-1 items-start md:items-center whitespace-nowrap min-w-[105px] md:min-w-auto ">
                        <i class="sctr-icon-bed-3 text-base leading-5 text-palette-gray-500"></i>
                        <h4 class="text-palette-gray-500 font-medium">{{'DETAIL.BED_TYPE' | translate}}:</h4>
                    </div>
                    <ng-container *ngIf="item.bed_types.length > 1;  else oneBedType">
                        <div class="flex !gap-4 flex-wrap items-start">
                            <div *ngFor="let bedType of item.bed_types"
                                class="custom-input flex items-center w-fit relative">
                                <p-radioButton [inputId]="bedType.bed_id + '-' + index" (onClick)="onChooseBedType(item)"
                                    name="bedType" [value]="bedType" [(ngModel)]="selectedBedType"
                                    [ngClass]="!selectedBedType && isClickedBook ? 'is-invalid' : '' ">
                                </p-radioButton>
                                <div class="ml-2 w-full whitespace-nowrap overflow-hidden text-ellipsis" #bedType
                                    (mouseover)="mouseOverBedType()">
                                    <span *ngFor="let item of bedType.bed_type; let last = last">
                                        <label [for]="bedType.bed_id + '-' + index"
                                            class="text-palette-gray-700">{{item.num_of_beds}} {{ item.bed_type_name |
                                            titlecase }}</label>
                                        <span *ngIf="!last"> + </span>
                                    </span>
                                </div>
                                <div class="tooltip-bedtype absolute top-0 right-0 hidden cursor-default text-center z-100 transition-opacity duration-200 ease-in !px-3 !py-2
                                    text-xs font-semibold text-palette-gray-700 bg-white rounded-lg whitespace-nowrap">
                                    <span *ngFor="let item of bedType.bed_type; let last = last">
                                        <label [for]="bedType.bed_type_id + '-' + index"
                                            class="ml-2 text-palette-gray-700">{{item.num_of_beds}} x {{ item.bed_type_name | titlecase }}</label>
                                        <span *ngIf="!last">, </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #oneBedType>
                        <label class="flex items-center pl-10 cursor-pointer custom-input">
                            <p-radioButton name="roomSelection" [value]="item.id"
                                [disabled]="item.bed_types[0]?.bed_type.length === 1" [(ngModel)]="selectedBedType"
                                [inputId]="'room-'+item.id"></p-radioButton>
    
                            <span *ngFor="let bedType of item.bed_types[0]?.bed_type; let last = last"
                                class="ml-2 text-palette-gray-700">
                                {{bedType.num_of_beds}} {{bedType.bed_type_name | titlecase }}
                                <span *ngIf="!last"> + </span>
                            </span>
                        </label>
                    </ng-template>
                </div>
    
                <div *ngFor="let rate_plan of item.rate_plan">
                    <div class="flex max-xl:flex-col max-xl:items-end justify-end bg-palette-gray-50 border md:border-0 border-palette-gray-200 !p-4 rounded-lg">
                        <div class="flex-1 w-full h-auto block md:flex items-start font-inter md:!gap-2 relative ">
                            <!--<div *ngIf="rate_plan.best_match"
                                style="background: linear-gradient(263.89deg, #FF692E 0%, #FF4405 100%);"
                                class="absolute bottom-0 left-0 w-[81px] h-[26px] rounded-tr-md rounded-bl-md text-xs !leading-[18px] font-medium text-white flex justify-center items-center">
                                {{ 'DETAIL.BEST_MATCH' | translate }}
                            </div>-->
                            <!-- 1. INCLUDED -->
                            <ng-container *ngIf="rate_plan?.meal_plan?.meal_plan_name || (rate_plan?.inclusions?.length > 0)">
                                <div [ngClass]="(checkDisplayTaxesAndCharge(rate_plan) || rate_plan?.max_adult_per_room != null) 
                                                ? 'w-full md:w-1/2 md:max-w-1/4' : 'w-full md:w-1/2'" class="min-h-full !pr-2 pb-1 md:py-0 h-full flex flex-col !gap-2 md:gap-1 
                                            border-b md:border-b-0 md:border-r border-dashed border-palette-gray-200
                                            min-w-[135px]">
                                    <p class="text-xs font-normal uppercase text-palette-gray-500">
                                        {{ 'DETAIL.INCLUDES' | translate }}
                                    </p>
                                    <div class="flex !flex-col !gap-1">
                                        <!-- MEAL PLAN -->
                                        <div *ngIf="rate_plan.meal_plan?.meal_plan_name"
                                            class="flex items-center !gap-1 relative text-palette-emerald-600 max-w-fit">
                                            <i class="sctr-icon-check-circle-broken"></i>
                                            <span
                                                [tooltip]="isBedAndBreakfast(rate_plan.meal_plan.meal_plan_name) ? ('COMMON.BED_AND_BREAKFAST' | translate) : ('DETAIL.' + formatToTranslateMeal(rate_plan.meal_plan.meal_plan_name) | translate)"
                                                [isTruncated]="true" [position]="TooltipPosition.BELOW"
                                                class="line-clamp-1! font-inter text-xs font-medium overflow-hidden text-ellipsis whitespace-nowrap">
                                                {{ isBedAndBreakfast(rate_plan.meal_plan.meal_plan_name)
                                                ? ('COMMON.BED_AND_BREAKFAST' | translate)
                                                : ('DETAIL.' + formatToTranslateMeal(rate_plan.meal_plan.meal_plan_name) | translate) }}
                                            </span>
                                        </div>
                                        <!-- INCLUSIONS -->
                                            <ng-container *ngFor="let inclusion of rate_plan?.inclusions?.slice(0, 3)">
                                                <div
                                                    class="flex items-start justify-start gap-1 max-w-fit">
                                                    <i
                                                        class="sctr-icon-check-circle-broken text-[16px] text-palette-gray-500"></i>
                                                    <span [tooltip]="translateInclusions(inclusion) | translate"
                                                        [isTruncated]="true" [position]="TooltipPosition.BELOW"
                                                        class="font-inter text-xs font-medium overflow-hidden text-ellipsis text-palette-gray-900 relative">
                                                        {{ translateInclusions(inclusion) | translate }}
                                                    </span>
                                                </div>
                                            </ng-container>
        
                                            <!-- {+x more} -->
                                            <div class="relative">
                                                <div *ngIf="rate_plan?.inclusions?.length > 3"
                                                    class="flex items-center gap-1 text-palette-blue-600 cursor-pointer max-w-fit relative "
                                                    [tooltip]="renderTooltipInclusion(rate_plan?.inclusions)" [position]="TooltipPosition.ABOVE">
                                                    <span class="font-inter text-xs font-medium whitespace-nowrap">
                                                        +{{ rate_plan.inclusions.length - 3 }} {{ 'COMMON.MORE' | translate}}
                                                    </span>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </ng-container>
                            <!-- 2. CANCELLATION -->
                            <div [ngClass]="(checkDisplayTaxesAndCharge(rate_plan) || rate_plan?.max_adult_per_room != null) 
                                            ? 'w-full md:w-1/2 max-w-1/4'  : 'w-full md:w-1/2'" class="min-h-fit !pr-2 py-1 md:py-0 border-b md:border-b-0 md:border-r 
                                        border-dashed border-palette-gray-200 h-full flex flex-col !gap-4">
                                <div class="flex flex-col !gap-1">
                                    <div class="relative flex items-center gap-1 whitespace-nowrap"
                                        (mouseenter)="showPolicyPopup(rate_plan)"
                                        (mouseleave)="hidePolicyPopup(rate_plan)">
                                        <p class="text-xs font-normal uppercase text-palette-gray-500">
                                            {{ 'DETAIL.CANCELLATION' | translate }}
                                        </p>
                                        <i class="sctr-icon-alert-circle text-xs text-palette-gray-500"></i>
                                        <div *ngIf="rate_plan.isShowPolicyPopup 
                                            && rate_plan.cancellation == 'Refundable'
                                            && (resourceID == 0 || resourceID == 2 || resourceID == 3 || resourceID == 5)"
                                            class="absolute bottom-full lg:left-[-50%] z-5 !mb-2">
                                            <app-cancellation-policy-popup
                                                [cancelPolicies]="rate_plan.cancellation_policy_object"
                                                [checkInDate]="checkInDate">
                                            </app-cancellation-policy-popup>
                                        </div>
                                    </div>
                                    <div class="flex items-center !gap-2">
                                        <div *ngIf="rate_plan.cancellation !== 'Refundable'; else Refundable"
                                            class="font-inter !leading-4 text-xs font-medium text-palette-gray-700 whitespace-nowrap">
                                            {{ 'COMMON.NON-REFUNDABLE' | translate }}
                                        </div>
                                        <ng-template #Refundable>
                                            <ng-container *ngIf="rate_plan.refundable">
                                            <!-- Resource id = 0 or Resource id = 2 or Resource id = 3-->
                                                <div class="font-inter !leading-4 text-xs font-medium text-palette-gray-700"
                                                    *ngIf="resourceID == 0 || resourceID == 2 || resourceID == 3 || resourceID == 5">
                                                    <div>
                                                        <app-short-cancellation-policy
                                                            [cancelPolicies]="rate_plan.cancellation_policy_object"
                                                            [checkInDate]="checkInDate">
                                                        </app-short-cancellation-policy>
                                                    </div>
                                                </div>
                                                <div *ngIf="resourceID == 1">
                                                    <div class="relative" *ngIf="rate_plan.cancellation_policy">
                                                        <i class="sctr-icon-info-circle text-[16px] text-palette-gray-400 cursor-pointer "
                                                            (mouseenter)="rate_plan.showTooltipPolicy = true"
                                                            (mouseleave)="rate_plan.showTooltipPolicy = false"></i>
                                                        <div *ngIf="rate_plan.showTooltipPolicy"
                                                            class="background-tooltip absolute z-[9999] right-[-80%] top-[110%] font-inter text-xs font-semibold rounded-lg text-center bg-opacity-90 text-palette-base-white p-2 shadow">
                                                            • {{ rate_plan.cancellation_policy }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-template>
                                    </div>
                                </div>
                                <!-- 3. PAYMENT: Only show below if Included -->
                                <ng-container *ngIf="rate_plan?.inclusions?.length > 0 || rate_plan.meal_plan?.meal_plan_name">
                                    <div class="flex flex-col gap-1">
                                        <p class="text-xs font-normal uppercase text-palette-gray-500">
                                            {{ 'DETAIL.PAYMENT' | translate }}
                                        </p>
                                
                                        <div class="flex items-center gap-1 ">
                                            <!-- Pay at the property -->
                                            <div *ngIf="!rate_plan?.is_prepayment_required" class="flex items-center gap-1">
                                                <span class="font-inter text-xs font-medium text-palette-emerald-600 whitespace-nowrap">
                                                    {{ 'DETAIL.PAY_AT_HOTEL' | translate }}
                                                </span>
                                                <!-- Tooltip -->
                                                <div class="relative">
                                                    <i class="sctr-icon-alert-circle text-palette-gray-500 text-xs cursor-pointer"
                                                        [tooltip]="'DETAIL.PAY_AT_HOTEL_TOOLTIP' | translate" [position]="TooltipPosition.ABOVE"></i>
                                                </div>
                                            </div>
                                            <!-- Prepayment -->
                                            <div *ngIf="rate_plan?.is_prepayment_required" class="font-inter text-xs font-medium text-palette-gray-900 whitespace-nowrap">
                                                {{ 'DETAIL.PREPAYMENT_NEEDED' | translate }}
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- 4. PAYMENT: Separate if NOT Included -->
                            <ng-container *ngIf="!rate_plan?.inclusions?.length && !rate_plan.meal_plan?.meal_plan_name">
                                <div [ngClass]="(checkDisplayTaxesAndCharge(rate_plan) || rate_plan?.max_adult_per_room != null) 
                                                                    ? 'w-full md:w-1/2' : 'w-full md:w-1/3'" class="min-h-full !pr-2 py-1 md:py-0 border-b md:border-b-0 md:border-r 
                                                                border-dashed border-palette-gray-200 h-full flex flex-col !gap-4">
                                    <div class="flex flex-col gap-1">
                                        <p class="text-xs font-normal uppercase text-palette-gray-500">
                                            {{ 'DETAIL.PAYMENT' | translate }}
                                        </p>
                            
                                        <div class="flex items-center gap-1">
                                            <!-- Pay at the property -->
                                            <div *ngIf="!rate_plan?.is_prepayment_required" class="flex items-center gap-1 relative">
                                                <span class="font-inter text-xs font-medium text-palette-emerald-600 whitespace-nowrap">
                                                    {{ 'DETAIL.PAY_AT_HOTEL' | translate }}
                                                </span>
                                                <!-- Tooltip -->
                                                <div class="relative">
                                                    <i class="sctr-icon-alert-circle text-palette-gray-500 text-xs cursor-pointer"
                                                        [tooltip]="'DETAIL.PAY_AT_HOTEL_TOOLTIP' | translate" [position]="TooltipPosition.ABOVE"></i>
                                                </div>
                                            </div>
                            
                                            <!-- Prepayment -->
                                            <div *ngIf="rate_plan?.is_prepayment_required"
                                                class="font-inter text-xs font-medium text-palette-gray-900 whitespace-nowrap">
                                                {{ 'DETAIL.PREPAYMENT_NEEDED' | translate }}
                                            </div>
                                        </div>
                                    </div>
                            
                                </div>
                            </ng-container>
                            <!-- Guest & Tax and fee -->
                            <div *ngIf="checkDisplayTaxesAndCharge(rate_plan) || rate_plan?.max_adult_per_room != null || rate_plan?.rate_comments"
                                class="w-full min-w-[125px] md:!w-[30%] min-h-full !pr-2 py-1 md:py-0 border-b md:border-b-0  md:border-r border-dashed border-palette-gray-200 h-full flex flex-col !gap-4">
                                <!-- Guest -->
                                <div class="flex flex-col !gap-1" *ngIf="rate_plan?.max_adult_per_room != null">
                                    <p class="text-xs font-normal uppercase text-palette-gray-500">{{'DETAIL.GUEST' | translate}}</p>
                                    <div>
                                        <p class="text-xs font-medium text-palette-gray-700">
                                            {{rate_plan.max_adult_per_room[0]}} {{'COMMON.ADULT' | translate: {syntax:
                                            rate_plan.max_adult_per_room[0] > 1 ? 's': ''} }}
                                            <span
                                                *ngIf="rate_plan.max_children_per_room[0] !== 0 && rate_plan.max_children_per_room.length !== 0"
                                                class="text-xs font-medium text-palette-gray-700">
                                                , {{rate_plan.max_children_per_room[0]}} {{rate_plan.max_children_per_room[0] >=
                                                2 ?
                                                ("COMMON.CHILDREN" | translate ) : ("COMMON.CHILD" | translate ) }}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <!-- Tax and fee -->
                                <div class="flex flex-col !gap-1" *ngIf="checkDisplayTaxesAndCharge(rate_plan)">
                                    <p *ngIf="resourceID !== 3" class="text-xs font-normal uppercase text-palette-gray-500">
                                        {{'DETAIL.TAXES_AND_CHARGES' | translate}}</p>
                                    <p *ngIf="resourceID === 3" class="text-xs font-normal uppercase text-palette-gray-500">
                                        {{'DETAIL.ADDITIONAL_SERVICES' | translate}}</p>
                                    <div class="flex items-center !gap-2">
                                        <p *ngIf="rate_plan?.tax_data?.taxes !== null && rate_plan?.tax_data?.taxes"
                                            class="text-sm font-medium text-palette-gray-700">
                                            {{getTotalTaxeCharge(rate_plan?.tax_data?.taxes) | currencyConversion}}
                                        </p>
                                        <div class="relative" *ngIf="getTotalTaxeCharge(rate_plan?.tax_data?.taxes) != 0">
                                            <i class="sctr-icon-info-circle text-[16px] text-palette-gray-400 cursor-pointer"
                                                (mouseenter)="rate_plan.showTooltipTaxes = true"
                                                (mouseleave)="rate_plan.showTooltipTaxes = false"></i>
                                            <div *ngIf="rate_plan.showTooltipTaxes"
                                                class="background-tooltip absolute z-[9999] right-[-80%] top-[110%] font-inter text-xs font-semibold rounded-lg text-center bg-opacity-90 !px-4 !py-2 shadow flex flex-col !gap-1">
                                                <div *ngFor="let item of rate_plan?.tax_data.taxes">
                                                    <div *ngIf="!item.included_by_supplier"
                                                        class="flex items-center font-inter !gap-2 text-xs font-normal text-white">
                                                        <p class="text-left flex-1 whitespace-nowrap">
                                                            {{convertToTitleCase(item.name)}}</p>
                                                        <p class="w-auto">{{item.amount | currencyConversion}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Note -->
                                <div *ngIf="rate_plan?.rate_comments && rate_plan?.rate_comments.trim() !== ''"
                                    class="flex flex-col !gap-1">
                                    <p class="text-xs font-normal uppercase text-palette-gray-500">{{'DETAIL.NOTE' | translate}}
                                    </p>
                                    <p class="text-xs font-medium text-palette-gray-700 line-clamp-2 cursor-pointer note-text whitespace-pre-line leading-none"
                                        pTooltip="{{ rate_plan.rate_comments }}" tooltipPosition="top"
                                        tooltipStyleClass="custom-tooltip">
                                        {{ rate_plan.rate_comments }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- Price -->
                        <div class="min-h-fit !pl-2 h-full py-1 md:py-0">
                            <div class="flex xl:flex-col !gap-2 justify-end w-full">
                                <!-- Price -->
                                <div class="flex flex-col justify-end">
                                    <!-- badge reduce amount -->
                                    <ng-container *ngIf="rate_plan.badge_info">
                                        <div class="ml-auto mt-auto w-fit rank-background !p-0.5 !h-6 flex items-center justify-end !gap-0.5 relative"
                                            (mouseover)="rate_plan.badge_info.rank_info.showTooltip = true"
                                            (mouseleave)="rate_plan.badge_info.rank_info.showTooltip = false">
                                            <img class="!w-5 !h-5 !p-0.5" src="{{baseImgUrl}}/{{ rate_plan.badge_info.rank_info.avatar}}.webp" alt="">
                                            <p class="text-xs font-normal text-palette-gray-500 whitespace-nowrap">
                                                {{ 'SEARCH_RESULT.DISCOUNT' | translate }}
                                            </p>
                                            <p class="text-sm font-semibold text-palette-gray-900 !pl-0.5 !pr-1">
                                                {{ rate_plan.badge_info.rank_info.reduce_amount | currencyConversion }}
                                            </p>
                                            <div *ngIf="rate_plan.badge_info.rank_info.showTooltip"
                                                class="absolute text-xs font-medium text-palette-gray-900 bg-palette-gray-50 
                                                    !px-3 !py-2 rounded shadow-md bottom-full mb-1 whitespace-nowrap z-10">
                                                {{ rate_plan.badge_info.rank_info.name }}
                                            </div>
                                        </div>
                                    </ng-container>
                                    <!-- origin price -->
                                    <div *ngIf="rate_plan?.origin_price && rate_plan?.origin_price > rate_plan?.net_price"
                                        class="text-sm font-normal text-palette-gray-400 line-through ml-auto">
                                        <app-price-format [price]="rate_plan.origin_price"></app-price-format>
                                    </div>
                                    <!-- net price -->
                                    <div class="flex items-center mt-[2px] ml-auto w-full">
                                        <div class="flex flex-col !gap-1 justify-end text-end w-full">
                                            <div class="flex justify-end md:items-end gap-2 mb-1">
                                                <ng-container *ngIf="rate_plan?.percentage_off > 0;">
                                                    <p
                                                        class=" bg-orange-100 text-amber-600 text-xs font-medium px-2 py-1 rounded self-start md:self-end whitespace-nowrap">
                                                        {{ 'DETAIL.OFF' | translate: { syntax: rate_plan.percentage_off } }}
                                                    </p>
                                                </ng-container>
                                                <div
                                                    class="text-palette-blue-600 text-xl max-[1600px]:!text-lg max-[1400px]:!text-base !text-[22px] leading-[30px] font-semibold flex justify-end text-right">
                                                    <app-price-format [price]="rate_plan.net_price"></app-price-format>
                                                </div>
                                            </div>
                                            <div class="relative w-full">
                                                <div [tooltip]="'PAYMENT.TOTAL_NIGHT_AFTER_TAXE_FEE' | translate: { syntax: calculateDateDifference(check_in, check_out) > 1 ?
                                                'nights': 'night', value: calculateDateDifference(check_in, check_out) > 1 ? calculateDateDifference(check_in, check_out) : 1}"
                                                    [isTruncated]="true"
                                                    class="font-inter text-xs font-normal text-palette-gray-400 text-right !mb-1 !-mt-1 w-full overflow-hidden text-ellipsis">
                                                    {{'PAYMENT.TOTAL_NIGHT_AFTER_TAXE_FEE' | translate: { syntax:
                                                    calculateDateDifference(check_in, check_out) > 1 ?
                                                    'nights': 'night', value: calculateDateDifference(check_in, check_out) > 1 ?
                                                    calculateDateDifference(check_in, check_out) : 1} }}
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <span *ngIf="resourceID === 0"
                                            class="text-palette-gray-500 text-sm font-normal">/{{'COMMON.NIGHT' | translate: {
                                            syntax: '' } }}</span> -->
                                    </div>
                                </div>
                                <!-- click book -->
                                <div class="ml-auto {{rate_plan?.promotionPercentage !== 0 ? '' : '!mt-4'}}">
                                    <!-- SOLD OUT -->
                                    <div *ngIf="!rate_plan?.net_price" class="mt-1">
                                        <div class="text-sm font-semibold text-center text-palette-gray-500 border-2 border-palette-gray-500 rounded-md px-4 py-2 opacity-50"
                                            style="box-shadow: 2px 1px 7px 0px rgba(0, 0, 0, 0.10);">
                                            {{ 'DETAIL.SOLD_OUT' | translate }}
                                        </div>
                                    </div>
                                    <div *ngIf="rate_plan?.net_price">
                                        <div *ngIf="is_support_multi_room"
                                            class="border border-palette-gray-300 bg-white w-[119px] h-[44px] rounded-md flex items-center justify-center relative">
                                            <div
                                                class="cursor-pointer absolute top-[50%] left-0 translate-y-[-45%] pl-[10px]">
                                                <i class="sctr-icon-minus text-[16px] text-palette-gray-600"
                                                    (click)="subtractNumberOfRoom(rate_plan, item)"></i>
                                            </div>
                                            <span
                                                class="text-sm font-semibold text-palette-gray-600">{{rate_plan?.numberRoomBuy}}</span>
                                            <div class="absolute right-0 top-[50%] cursor-pointer translate-y-[-45%]">
                                                <i class="sctr-icon-plus text-[16px] text-branding-primary-700 pr-[10px]"
                                                    (click)="plusNumberOfRoom(rate_plan, item)"></i>
                                            </div>
                                        </div>
                                        <div *ngIf="!is_support_multi_room" class="!mt-1">
                                            <div pButton (click)="handleClickBookRoom(rate_plan, item)"
                                                class="btn-book-now font-inter text-sm font-semibold flex justify-center items-center whitespace-nowrap cursor-pointer transition-all">
                                                {{'DETAIL.BOOK_ROOM' | translate}}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- NUMBER ROOM SOLDOUT -->
                                    <!-- <p class="mt-1 text-sm font-normal text-palette-amber-600 text-end">
                                        2 rooms sold today
                                    </p> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-toast></app-toast>
